module.exports = __webpack_public_path__ + "9d049f8ba9fe2a26c76e7f144769bb56.svg";